import React from "react";
import { NavLink, useLocation } from "react-router-dom";
import { Home, Trophy, Users, Gem, User } from "lucide-react";

const items = [
  { to: "/dashboard", label: "Home", icon: Home, tid: "bottom-nav-home" },
  { to: "/contests", label: "Contests", icon: Trophy, tid: "bottom-nav-contests" },
  { to: "/my-circles", label: "My Circles", icon: Users, tid: "bottom-nav-my-circles" },
  { to: "/vault", label: "Vault", icon: Gem, tid: "bottom-nav-vault" },
  { to: "/profile", label: "Profile", icon: User, tid: "bottom-nav-profile" },
];

export default function BottomNav() {
  const loc = useLocation();
  return (
    <nav
      data-testid="bottom-nav"
      className="fixed bottom-0 left-0 right-0 z-40 glass-strong border-t border-white/10"
      style={{ paddingBottom: "env(safe-area-inset-bottom)" }}
    >
      <ul className="max-w-xl mx-auto grid grid-cols-5 px-2">
        {items.map(({ to, label, icon: Icon, tid }) => {
          const active = loc.pathname.startsWith(to);
          return (
            <li key={to} className="flex">
              <NavLink
                to={to}
                data-testid={tid}
                className={`flex-1 flex flex-col items-center justify-center py-3 gap-1 text-[11px] tracking-widest uppercase font-semibold transition ${
                  active ? "text-white" : "text-white/55 hover:text-white"
                }`}
              >
                <span className={`relative flex items-center justify-center w-10 h-10 rounded-2xl ${active ? "bg-white/10" : ""}`}>
                  <Icon className="w-5 h-5" style={active ? { filter: "drop-shadow(0 0 8px #00F0FF)" } : {}} />
                </span>
                <span>{label}</span>
                {active && <span className="absolute bottom-1 h-[3px] w-8 rounded-full" style={{ background: "linear-gradient(90deg,#B026FF,#00F0FF)" }} />}
              </NavLink>
            </li>
          );
        })}
      </ul>
    </nav>
  );
}
